/* global google */
import React, { useEffect, useRef } from "react";
import { loadGoogleMaps } from "../utils/loadGoogleMaps";

const GMAPS_KEY = process.env.REACT_APP_GMAPS_KEY;

export default function AddressAutocompleteInput({ onPlace }) {
  const inputRef = useRef(null);

  useEffect(() => {
    let ac;
    (async () => {
      await loadGoogleMaps(GMAPS_KEY);
      if (!window.google?.maps?.places || !inputRef.current) return;

      const sessionToken = new google.maps.places.AutocompleteSessionToken();
      ac = new google.maps.places.Autocomplete(inputRef.current, {
        fields: ["place_id", "formatted_address", "geometry", "address_components"],
        types: ["address"],
        componentRestrictions: { country: "pl" },
      });
      ac.setOptions({ sessionToken });

      ac.addListener("place_changed", () => {
        const p = ac.getPlace();
        if (!p?.geometry?.location) return;

        let street = "", houseNumber = "", city = "", postalCode = "";
        if (Array.isArray(p.address_components)) {
          for (const c of p.address_components) {
            const t = c.types || [];
            if (t.includes("route")) street = c.long_name || street;
            if (t.includes("street_number")) houseNumber = c.long_name || houseNumber;
            if (t.includes("locality") || t.includes("postal_town")) city = c.long_name || city;
            if (t.includes("postal_code")) postalCode = c.long_name || postalCode;
          }
        }

        onPlace?.({
          placeId: p.place_id,
          address: p.formatted_address,
          street,
          houseNumber,
          city,
          postalCode,
          lat: p.geometry.location.lat(),
          lng: p.geometry.location.lng(),
        });
      });
    })();
    return () => { ac = null; };
  }, []);

  return (
    <input
      ref={inputRef}
      className="location-modal-input"
      placeholder="Ulica i numer (np. Długa 12)"
      autoFocus
    />
  );
}
